
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/show/[id]",
      function () {
        return require("private-next-pages/show/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/show/[id]"])
      });
    }
  